<template>
  <div class="parts-list-container">
    <h2 class="chatbot-name">{{chatbot.name}}</h2>
    <div class="parts-list disp-scroll" v-if="!isLoading">
      <h2 class="all-name">全 {{scenarioLength}}個 / {{1200}}円</h2>
      <template v-if="scenarioLength > 0">
        <article v-for="(s, idx) in Object.keys(aggScenario)" :key="idx" class="parts-card">
          <div>
            <h2 class="status-name">{{getPartsName(aggScenario[s].status)}}</h2>
            <div class="detail">
              <img class="img-icon" :src="getPartsImage(aggScenario[s].status)"/>
              <p class="info">{{aggScenario[s].cnt}}個 / {{10}}円</p>
            </div>
          </div>
        </article>
      </template>
      <template v-else>
        <p>パーツがありません。</p>
      </template>
    </div>
    <div class="parts-list" v-else>
      <span class="mdi mdi-loading mdi-spin"></span>
    </div>
  </div>
</template>

<script>
import cardList from '@/assets/json/master/scenario.json'
export default {
  props: {
    chatbot: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      scenario: [],
      cardList: cardList,
      isLoading: false
    }
  },
  created () {
    this.isLoading = true
    if (this.type === 'store') {
      this.scenario = this.chatbot.scenario_list
      this.isLoading = false
    } else {
      this.$store.dispatch('chatbot/getScenarioList', { companyid: this.chatbot.group, scenarioName: this.chatbot.scenario_name })
      .then((d) => {
        setTimeout(() => {
          this.scenario = this.$_.cloneDeep(d.data)
          this.isLoading = false
        }, 200)
      })
    }
  },
  computed: {
    aggScenario () {
      let ret = {}
      for (const s of this.scenario) {
        ret[s.status] = s
        ret[s.status].cnt = ret[s.status].cnt ? ret[s.status].cnt++ : 1
      }
      return ret
    },
    scenarioLength () {
      return this.scenario.length
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    getPartsName (status) {
      const idx = this.$_.findIndex(this.cardList, ['statusIdx', status + 1])
      return this.cardList[idx].name
    },
    getPartsImage (status) {
      const idx = this.$_.findIndex(this.cardList, ['statusIdx', status + 1])
      return require('../../../assets/template/' + this.cardList[idx].img)
    }
  }
}
</script>

<style lang="scss" scoped>
.parts-list-container {
  padding: 16px;
  .chatbot-name {
    margin: 16px;
    text-align: left;
    font-size: 24px;
    font-weight: 600;
    color: #C82E42;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.parts-list {
  width: 100%;
  height: 500px;
  padding: 16px 32px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  border: solid thin #ccc;
  h2.all-name {
    width: 100%;
    text-align: left;
    margin: 8px;
    font-size: 24px;
    font-weight: 600;
  }
  .parts-card {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    width: calc(33% - 8px);
    margin: 4px;
    border: solid thin #ccc;
    border-radius: 8px;
    text-align: center;
    h2.status-name {
      font-weight: 600;
      text-align: center;
      width: 100%;
      font-size: 14px;
    }
    .img-icon {
      width: 60%;
    }
  }
  .detail {
    margin-top: 8px;
  }
  .info {
    margin-top: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailPartsList.vue